export default __webpack_public_path__ + "static/media/02a_fold-7.28a19205.mp4";